// extracted by mini-css-extract-plugin
export var center = "_11-2";
export var clickableRow = "_11-5";
export var expandedRow = "_11-7";
export var hoverable = "_11-4";
export var left = "_11-1";
export var right = "_11-3";
export var row = "_11-0";
export var selectedRow = "_11-6";
export var summaryRow = "_11-8";